// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__4JY4j","location":"Header_location__3-K3t"};